import type { AudienceForm, GroupLike } from '../types.ts';

const countGroups = (groups: GroupLike[]): number => {
  let count = 0;

  for (const group of groups) {
    count += 1;

    if ('groups' in group && Array.isArray(group.groups)) {
      count += countGroups(group.groups);
    }

    if (count > 1) {
      return count;
    }
  }

  return count;
};

export const hasMoreThanOneGroupOrSubGroup = (definition: AudienceForm['normalized_definition']): boolean => {
  const includesCount = countGroups(definition.includes.groups);

  if (includesCount > 1) return true;

  if (includesCount < 1) return false;

  const excludesCount = countGroups(definition.excludes.groups);

  return includesCount + excludesCount > 1;
};
